/* eslint-disable no-nested-ternary */
import React, {useState, useEffect} from "react";
// import ProfilePic from "./images/customer.png";
import GmailIcon from "./images/google-logo.png";
import BasicIcon from "./images/basic-detail.png";
import Financing from "./images/financing.png";
import tradeInIcon from "./images/trade-in-icon.svg";
import loadable from "@loadable/component";
import styles from "./styles.css";

const PreApprovalEditFlow = loadable(() => import("../pre-approval-financing-flow/pre-approval-edit-flow"));
// import NameIcon from "./images/name-icon.png";
// import EmailIcon from "./images/email-icon.png";
import AppleIcon from "./images/apple.svg";
import FacebookIcon from "./images/facebook.svg";
import { AUTH_ADDRESS } from "../../../constants/api-constants";
import PropTypes from "prop-types";
// import FinancingNotFound from "../financing-not-found";
import { myAccountRoutes, myAccountRoutesArray } from "../../../constants/my-accounts-routes";
import { useHistory, useParams } from "react-router";
import AvatarText from "../../shared/avatar-text/avatar-text";
import Loader from "../../shared/loader";
import withLogin from "../with-login";
import parseCookie from "../../../utils/helpers/parse-cookie";
import { EXPERIMENT_TYPE } from "../../../constants/optimize-constants";

import { AU_DESKTOP_EVENTS } from "../../../tracking/au.desktop-events";
import { trackDesktopCustomEventsAU } from "../../../tracking";
import { redirectToUrl } from "../../../utils/helpers/redirect-to-url";

const financeMyAccountStepId = ["loan-details",  "financing"];

const getIcon = (key) => {
    switch (key) {
    case myAccountRoutes.myAccount.key:
        return BasicIcon;
    case myAccountRoutes.financing.key:
        return Financing;
    case myAccountRoutes.tradeIn.key:
        return tradeInIcon;
    default:
        return BasicIcon;
    }
};

// eslint-disable-next-line  max-statements
const MyAccountSidebar = ({
    userProfiles,
    profileName,
    isLoggedIn,
    preApprovalEditMode,
    getPreApprovalLoanDetailsConnect,
    getDepositRangeValueConnect,
    openLoginPopupConnect,
    setOnLoginCloseCallback,
    getInhouseEligibilityConnect,
    getInhousePreApprovalLoanDetailsConnect,
    isFetched
}) => {
    const [isLoading, setIsLoading] = useState();
    const history = useHistory();
    const params = useParams();
    const [activeTab, setActiveTab] = useState(myAccountRoutes.myAccount.key);
    const [authProviderLogo, setAuthProviderLogo] = useState(null);
    const {stepId = ""} = params;

    useEffect(() => {
        if (!isLoggedIn && !financeMyAccountStepId.includes(stepId)) {
            openLoginPopupConnect();
            setOnLoginCloseCallback(() => {
                redirectToUrl();
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLoggedIn]);

    useEffect(() => {
        const currentStep = myAccountRoutesArray.filter((value) => myAccountRoutes[value].route === params.stepId);
        setActiveTab(currentStep.length ? currentStep[0] : myAccountRoutes.myAccount.key);
    }, [params, params.stepId]);

    useEffect(() => {
        if (userProfiles && userProfiles.length) {
            switch (userProfiles[0].addressType) {
            case AUTH_ADDRESS.GOOGLE:
                setAuthProviderLogo(GmailIcon);
                break;
            case AUTH_ADDRESS.APPLE:
                setAuthProviderLogo(AppleIcon);
                break;
            case AUTH_ADDRESS.FACEBOOK:
                setAuthProviderLogo(FacebookIcon);
                break;
            default:
                break;
            }
        }
    }, [userProfiles]);

    const handleRoutes = (key) => {
        if (myAccountRoutes[key].route === myAccountRoutes.tradeIn.route) {
            trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.MY_ACCOUNT_SELL_OR_TRADE_IN);
        }
        history.replace(`/my-account/${myAccountRoutes[key].route}`);
    };
    const getPreApproval = async (eligible) => {
        try {
            setIsLoading(true);
            if (eligible) {
                getDepositRangeValueConnect();
                await getInhousePreApprovalLoanDetailsConnect({fetchListingDetails: true});
            } else {
                getDepositRangeValueConnect();
                await getPreApprovalLoanDetailsConnect({fetchListingDetails: true});
            }
            setIsLoading(false);
        } catch (err) {
            setIsLoading(false);
            // console.log(err);
        }
    };

    const decideFlow = async () => {
        const isInhouseVariantFromCookie = parseCookie("show_in_house_finance");
        const isInhouseFlow = (isInhouseVariantFromCookie === EXPERIMENT_TYPE.VARIANT_B);
        if (isInhouseFlow) {
            try {
                const response = await getInhouseEligibilityConnect();
                getPreApproval(response.eligible);
            } catch (err) {
                getPreApproval();
            }
        } else {
            getPreApproval();
        }
    };

    useEffect(() => {
        if (!isFetched) return;
        setIsLoading(true);
        decideFlow();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isFetched, isLoggedIn]);

    const PRE_APPROVAL_EDIT_FLOW = ["loan-details", "employment-details", "personal-details"].includes((params || {}).stepId);
    //&& history.location.pathname.includes("au/my-account/financing");
    const Component = myAccountRoutes[activeTab].component;

    return (
        <div styleName={"styles.wrapper"}>
            <div styleName={"styles.leftWrapper"}>
                <div styleName={"styles.customerWrap"}>
                    <div styleName={"styles.profilePic"}>
                        <AvatarText fullName={profileName} />
                        {/* <img src={ProfilePic} alt="Profile Picture" /> */}
                        {authProviderLogo && <img src={authProviderLogo} alt="auth provider" />}
                    </div>
                </div>
                {
                    (myAccountRoutesArray || []).map((data) =>
                        (myAccountRoutes[data].showMenuSidebar && <div styleName={`styles.itemsWrapper ${activeTab === data ? "styles.active" : ""}`} key={myAccountRoutes[data].key} onClick={() => handleRoutes(myAccountRoutes[data].key)}>
                            <p styleName={"styles.item"}><img src={getIcon(myAccountRoutes[data].key)} alt={myAccountRoutes[data].name} />{myAccountRoutes[data].name}</p>
                        </div>)
                    )
                }
            </div>
            <div styleName={"styles.rightWrapper"}>
                {isLoading && activeTab === myAccountRoutes.financing.key ?
                    <Loader /> :
                    preApprovalEditMode && PRE_APPROVAL_EDIT_FLOW ?
                        <PreApprovalEditFlow /> :
                        <Component />
                }
            </div>
            {/* <div styleName={"styles.notFoundContainer"}>
                <FinancingNotFound />
            </div> */}
        </div>
    );
};

MyAccountSidebar.propTypes = {
    userProfiles: PropTypes.array,
    profileName: PropTypes.string,
    secureToken: PropTypes.string,
    isLoggedIn: PropTypes.bool,
    preApprovalEditMode: PropTypes.bool,
    getPreApprovalLoanDetailsConnect: PropTypes.func,
    openLoginPopupConnect: PropTypes.func,
    setOnLoginCloseCallback: PropTypes.func,
    getDepositRangeValueConnect: PropTypes.func,
    getInhousePreApprovalLoanDetailsConnect: PropTypes.func,
    getInhouseEligibilityConnect: PropTypes.func,
    isFetched: PropTypes.bool
};

export default withLogin(MyAccountSidebar);
